var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-data-table", {
    attrs: {
      columns: _vm.cols,
      items: _vm.purchase.Ledgers,
      "selected-items": _vm.selectedItems,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }